import { CoachListData, CoachListPayload } from '@/new-transport/_models/transport-coach-list.model';

/**
 * Transforms an array of CoachListData into an array of CoachListPayload,
 * extracting necessary IDs and fields from nested slotVehicle structures.
 *
 * @param {CoachListData[]} payloadToMap - The input coach data list.
 * @returns {CoachListPayload[]} - The mapped list ready for backend consumption.
 */
export function mapCoachListToCreatePayload(payloadToMap: CoachListData[]): CoachListPayload[] {
	return payloadToMap.map(({ id, slotVehicles }) => {
		const mappedSlotVehicles = slotVehicles.map(({ id, vehicle, seat, side, order }) => ({
			id,
			vehicle: vehicle.id,
			seat: seat.id,
			side,
			order,
		}));

		return {
			id,
			slotVehicles: mappedSlotVehicles,
		};
	});
}
